// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressToJSON,
    ClaimEligibilityItem,
    ClaimEligibilityItemFromJSON,
    ClaimEligibilityItemToJSON,
    ClaimEligibilityValidation,
    ClaimEligibilityValidationFromJSON,
    ClaimEligibilityValidationToJSON,
    EligibilityType,
    EligibilityTypeFromJSON,
    EligibilityTypeToJSON,
    SexType,
    SexTypeFromJSON,
    SexTypeToJSON,
    SupportClaimEligibilityDependent,
    SupportClaimEligibilityDependentFromJSON,
    SupportClaimEligibilityDependentToJSON,
    SupportClearinghousePayer,
    SupportClearinghousePayerFromJSON,
    SupportClearinghousePayerToJSON,
    Tags,
    TagsFromJSON,
    TagsToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportClaimEligibility
 */
export interface SupportClaimEligibility extends Tags {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    id?: string;
    /**
     * The external id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    externalId?: string;
    /**
     * The information source name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    informationSourceName?: string;
    /**
     * The first name of the subscriber
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    first?: string;
    /**
     * The middle name of the subscriber
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    middle?: string;
    /**
     * The last name of the subscriber
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    last?: string;
    /**
     * 
     * OpenAPI data type: {Address}
     * @type {Address}
     * @memberof SupportClaimEligibility
     */
    address?: Address;
    /**
     * The date of birth of the subscriber
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaimEligibility
     */
    dob?: string;
    /**
     * 
     * OpenAPI data type: {SexType}
     * @type {SexType}
     * @memberof SupportClaimEligibility
     */
    sex?: SexType;
    /**
     * The member plan id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    planId?: string;
    /**
     * The member plan description
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    planDescription?: string;
    /**
     * The member group id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    groupId?: string;
    /**
     * The member group description
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    groupDescription?: string;
    /**
     * The member other qualifier id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    otherQualifierId?: string;
    /**
     * The member other id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    otherId?: string;
    /**
     * The member other description
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    otherDescription?: string;
    /**
     * The plan start date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaimEligibility
     */
    planStartDate?: string;
    /**
     * The plan end date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaimEligibility
     */
    planEndDate?: string;
    /**
     * Eligibility validation information
     * OpenAPI data type: {array}
     * @type {Array<ClaimEligibilityValidation>}
     * @memberof SupportClaimEligibility
     */
    validations?: Array<ClaimEligibilityValidation>;
    /**
     * Eligibility item information
     * OpenAPI data type: {array}
     * @type {Array<ClaimEligibilityItem>}
     * @memberof SupportClaimEligibility
     */
    items?: Array<ClaimEligibilityItem>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportClaimEligibilityDependent>}
     * @memberof SupportClaimEligibility
     */
    dependents?: Array<SupportClaimEligibilityDependent>;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    clearinghousePayerId?: string;
    /**
     * 
     * OpenAPI data type: {SupportClearinghousePayer}
     * @type {SupportClearinghousePayer}
     * @memberof SupportClaimEligibility
     */
    clearinghousePayer?: SupportClearinghousePayer;
    /**
     * 
     * OpenAPI data type: {EligibilityType}
     * @type {EligibilityType}
     * @memberof SupportClaimEligibility
     */
    type?: EligibilityType;
    /**
     * User markable as starred
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClaimEligibility
     */
    starred?: boolean;
    /**
     * Is active
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClaimEligibility
     */
    active?: boolean;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaimEligibility
     */
    created?: string;
    /**
     * The professional id used to run eligibility
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaimEligibility
     */
    professionalId?: string;
}

export function SupportClaimEligibilityFromJSON(json: any): SupportClaimEligibility {
    return {
                'id': !exists(json, 'id') ? undefined : json['id'],
                'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
                'informationSourceName': !exists(json, 'informationSourceName') ? undefined : json['informationSourceName'],
                'first': !exists(json, 'first') ? undefined : json['first'],
                'middle': !exists(json, 'middle') ? undefined : json['middle'],
                'last': !exists(json, 'last') ? undefined : json['last'],
                'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
                'dob': !exists(json, 'dob') ? undefined : json['dob'],
                'sex': !exists(json, 'sex') ? undefined : SexTypeFromJSON(json['sex']),
                'planId': !exists(json, 'planId') ? undefined : json['planId'],
                'planDescription': !exists(json, 'planDescription') ? undefined : json['planDescription'],
                'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
                'groupDescription': !exists(json, 'groupDescription') ? undefined : json['groupDescription'],
                'otherQualifierId': !exists(json, 'otherQualifierId') ? undefined : json['otherQualifierId'],
                'otherId': !exists(json, 'otherId') ? undefined : json['otherId'],
                'otherDescription': !exists(json, 'otherDescription') ? undefined : json['otherDescription'],
                'planStartDate': !exists(json, 'planStartDate') ? undefined : json['planStartDate'],
                'planEndDate': !exists(json, 'planEndDate') ? undefined : json['planEndDate'],
                'validations': !exists(json, 'validations') ? undefined : (json['validations'] as Array<any>).map(ClaimEligibilityValidationFromJSON),
                'items': !exists(json, 'items') ? undefined : (json['items'] as Array<any>).map(ClaimEligibilityItemFromJSON),
                'dependents': !exists(json, 'dependents') ? undefined : (json['dependents'] as Array<any>).map(SupportClaimEligibilityDependentFromJSON),
                'clearinghousePayerId': !exists(json, 'clearinghousePayerId') ? undefined : json['clearinghousePayerId'],
                'clearinghousePayer': !exists(json, 'clearinghousePayer') ? undefined : SupportClearinghousePayerFromJSON(json['clearinghousePayer']),
                'type': !exists(json, 'type') ? undefined : EligibilityTypeFromJSON(json['type']),
                'starred': !exists(json, 'starred') ? undefined : json['starred'],
                'active': !exists(json, 'active') ? undefined : json['active'],
                'created': !exists(json, 'created') ? undefined : json['created'],
                'professionalId': !exists(json, 'professionalId') ? undefined : json['professionalId'],
        ...TagsFromJSON(json)
    };

}

export function SupportClaimEligibilityToForm(value?: SupportClaimEligibility): any {
    let jsonVal = SupportClaimEligibilityToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportClaimEligibilityToJSON(value?: SupportClaimEligibility): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'externalId': cleanupBlankValuesForBackend(value.externalId),
            'informationSourceName': cleanupBlankValuesForBackend(value.informationSourceName),
            'first': cleanupBlankValuesForBackend(value.first),
            'middle': cleanupBlankValuesForBackend(value.middle),
            'last': cleanupBlankValuesForBackend(value.last),
            'address': AddressToJSON(value.address),
            'dob': cleanupBlankValuesForBackend(value.dob),
            'sex': SexTypeToJSON(value.sex),
            'planId': cleanupBlankValuesForBackend(value.planId),
            'planDescription': cleanupBlankValuesForBackend(value.planDescription),
            'groupId': cleanupBlankValuesForBackend(value.groupId),
            'groupDescription': cleanupBlankValuesForBackend(value.groupDescription),
            'otherQualifierId': cleanupBlankValuesForBackend(value.otherQualifierId),
            'otherId': cleanupBlankValuesForBackend(value.otherId),
            'otherDescription': cleanupBlankValuesForBackend(value.otherDescription),
            'planStartDate': cleanupBlankValuesForBackend(value.planStartDate),
            'planEndDate': cleanupBlankValuesForBackend(value.planEndDate),
            'validations': (value.validations === undefined || value.validations === null) ? undefined  : (value.validations as Array<any>).map(ClaimEligibilityValidationToJSON),
            'items': (value.items === undefined || value.items === null) ? undefined  : (value.items as Array<any>).map(ClaimEligibilityItemToJSON),
            'dependents': (value.dependents === undefined || value.dependents === null) ? undefined  : (value.dependents as Array<any>).map(SupportClaimEligibilityDependentToJSON),
            'clearinghousePayerId': cleanupBlankValuesForBackend(value.clearinghousePayerId),
            'clearinghousePayer': SupportClearinghousePayerToJSON(value.clearinghousePayer),
            'type': EligibilityTypeToJSON(value.type),
            'starred': cleanupBlankValuesForBackend(value.starred),
            'active': cleanupBlankValuesForBackend(value.active),
            'created': cleanupBlankValuesForBackend(value.created),
            'professionalId': cleanupBlankValuesForBackend(value.professionalId),
            ...TagsToJSON(value)
    };
}


